module.exports = __webpack_public_path__ + "img/运动装备-4.9928e61a.png";